import { useEffect, useState } from 'react';

const modalStoragePrefix = 'modal::';

export function useDismissableModal(modalName: string) {
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    function getValue() {
      var alreadySeen = localStorage.getItem(modalStoragePrefix + modalName);
      if (alreadySeen !== 'true') {
        setShowModal(true);
      }
    }
    getValue();
  }, [modalName]);

  function dismissModal(remember: boolean) {
    setShowModal(false);
    if (remember) {
      localStorage.setItem(modalStoragePrefix + modalName, 'true');
    }
  }

  return { showModal, dismissModal };
}
